function _templateObject() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { css, createGlobalStyle } from "styled-components";
var style = css(["html{font-size:62.5%;height:100%;}body{margin:0;padding:0;font-size:", ";font-family:", ";color:", ";height:100%;line-height:1.4;}input,select,textarea,button,option{font-family:inherit;font-size:inherit;}main{display:block;}.grow{flex-grow:1;}.has-text-centered{text-align:center;}.is-text-light{color:", ";}.no-margin{margin:0;}.no-padding{padding:0;}.pb-2{padding-bottom:2rem;}table{width:100%;display:table;border-collapse:collapse;border-spacing:0;thead{display:table-header-group;th{color:", ";font-weight:600;}}tbody{> tr:last-child{border-bottom:none;td{border-bottom:none;}}}tr{color:inherit;height:36px;display:table-row;outline:none;vertical-align:middle;border-bottom:1px solid ", ";}th{color:", ";font-weight:400;display:table-cell;text-align:left;vertical-align:inherit;padding:1px;color:", ";font-weight:600;}td{color:", ";font-weight:400;display:table-cell;text-align:left;vertical-align:inherit;padding:1px;}}a{color:", ";text-decoration:none;}ul{margin-top:0;margin-bottom:1rem;list-style-type:disc;margin-block-start:1em;margin-block-end:1em;margin-inline-start:0px;margin-inline-end:0px;padding-inline-start:40px;}#root{display:flex;flex-direction:column;min-height:100%;height:100%;}.App{flex:1 0 auto;}.inner-addon{position:relative;}.inner-addon .icon{position:absolute;pointer-events:none;top:50%;transform:translateY(-50%);}.left-addon .icon{left:0px;}.right-addon .icon{right:0px;}.left-addon input{padding-left:30px;}.right-addon input{padding-right:30px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fsBase;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.greyAdobe11;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.greyAdobe10;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.greyEnterprise4;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.greyBackground;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.greyAdobe13;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.greyEnterprise4;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.greyAdobe13;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.greyAdobe14;
});
export default createGlobalStyle(_templateObject(), style);